import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledLinkComponent } from "./link-component.scss";
import { withGenericConfig } from "contexts/generic-config-context";
import PictureComponent from "/components/core/picture/picture-component";
class LinkComponent extends PureComponent {
    render() {
        const { title, url, translate, onClickFunc, icon } = this.props;
        return /*#__PURE__*/ _jsxs(StyledLinkComponent, {
            className: "link-mobile-component",
            href: url,
            onClick: onClickFunc,
            children: [
                translate(title),
                icon && /*#__PURE__*/ _jsx(PictureComponent, {
                    className: "mobile-link-icon",
                    src: icon,
                    alt: translate(title)
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export default withGenericConfig(LinkComponent);
